import { useCallback } from "react"
import { useDispatch, useSelector } from "react-redux";
import API from "service/API"
import { setLoading } from "store/actionReducers/LoadingStore";
import { setNews } from "store/actionReducers/NewsStore";

const useNews = () => {
  const dispatch = useDispatch();
  const NewsStore = useSelector((state: any) => state?.NewsStore)

  const fetchNews = useCallback(async (params: any) => {
    if (params?.stock) {
      dispatch(setLoading({ value: 'news' }))
      const res = await API.News.getNews(params?.stock, { page: params.page, size: params.size });
      if (res?.code === '0') {
        let listOld = [...NewsStore?.news]
        listOld = listOld.concat(res?.data?.data)
        dispatch(setNews(listOld))
        dispatch(setLoading({ value: 'news' }))
      }
    }

  }, [NewsStore?.news]);

  return { fetchNews }
}
export default useNews